export interface INotification {
  warnings: boolean;
  alert: boolean;
  recommendations: boolean;
  actions: boolean;
}

export enum RoleType {
  Guest,
  AIDeveloper,
  Operator,
  Administrator
}

export interface IUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: RoleType;
  notification: INotification;
  culture: string;
  password: string;
  createdAt: Date;
  lastLoginDate: Date;
  assignments: IAssignment[];
}

export interface IAssignment {
  installationId: string;
  role: RoleType;
}
